export default [
  {
    header: 'navbars.contracts',
    permission: ['sales_management', 'supervisor', 'manager', 'super_manager'],
    unique_name: 'unsigned-contracts',
  },
  {
    title: 'contract.unsigned_contracts',
    route: 'unsigned-contracts',
    icon: 'FileIcon',
    permission: ['sales_management', 'manager', 'super_manager'],
    unique_name: 'unsigned-contracts',
  },
  {
    title: 'contract.signed_contracts',
    route: 'signed-contracts',
    icon: 'FilePlusIcon',
    permission: ['sales_management', 'supervisor', 'manager', 'super_manager'],
    unique_name: 'signed-contracts',
  },
  {
    title: 'contract.requests_to_edit',
    route: 'requests-list',
    icon: 'FilePlusIcon',
    permission: ['sales_management', 'supervisor', 'super_manager'],
    unique_name: 'contract-requests-to-edit',
  },
]